import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
  signal,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { uiKitScope } from '../../constants/ui-constant';
import { provideUiKitScope } from '../../providers';

const HEX_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

@Component({
  selector: 'ui-form-color-picker',
  imports: [TranslocoDirective],
  templateUrl: './form-color-picker.component.html',
  styleUrl: './form-color-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormColorPickerComponent {
  protected readonly uiKitScope = uiKitScope;

  value = model<string>('#000000');
  dataCy = input<string>('');
  invalidMessage = input<string>('');

  protected readonly hasError = signal<boolean>(false);

  protected readonly safeSwatchValue = computed(() => {
    const v = this.value();
    return HEX_REGEX.test(v) ? v : '#000000';
  });

  protected onChange(raw: string): void {
    if (!HEX_REGEX.test(raw)) {
      this.hasError.set(true);
      return;
    }
    this.hasError.set(false);
    this.value.set(raw);
  }
}
